__turbopack_context__.v({
  "active": "worlds-drawer-module__-Kii-G__active",
  "assetsDrawer": "worlds-drawer-module__-Kii-G__assetsDrawer",
  "buttonText": "worlds-drawer-module__-Kii-G__buttonText",
  "cardImage": "worlds-drawer-module__-Kii-G__cardImage",
  "categoryButton": "worlds-drawer-module__-Kii-G__categoryButton",
  "categoryButtons": "worlds-drawer-module__-Kii-G__categoryButtons",
  "pagination": "worlds-drawer-module__-Kii-G__pagination",
  "selected": "worlds-drawer-module__-Kii-G__selected",
  "title": "worlds-drawer-module__-Kii-G__title",
  "topSection": "worlds-drawer-module__-Kii-G__topSection",
  "worldCard": "worlds-drawer-module__-Kii-G__worldCard",
  "worldsGrid": "worlds-drawer-module__-Kii-G__worldsGrid",
});
